import { useSearchParams } from 'react-router-dom';

import type { NoteVariant } from '@/providers/rxdb/constants';

const validDraftTypes: NoteVariant[] = ['notes', 'templates'];

export const useDraftParams = () => {
  const [searchParams] = useSearchParams();
  const raw = searchParams.get('draftType');
  const draftType: NoteVariant = validDraftTypes.includes(raw as NoteVariant) ? (raw as NoteVariant) : 'notes';
  const creatingMedicalNote = searchParams.get('domain') === 'medical';
  return { draftType, creatingMedicalNote };
};
